import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AccountDetailsPage } from './account-details.page';

const routes: Routes = [
  {
    path: '',
    component: AccountDetailsPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class AccountDetailsPageRoutingModule {}
